// PPE 2.0 (DEV-4849): CRUD + lifecycle client for channel-rooted margin plans (MarginPlanController).
// Every call skips the global forbidden-reload: GETs degrade to the seed empty-state, and WRITES surface
// a 403 inline through the thunks' mutation-error slice instead of triggering the page reload interceptor.
import { SKIP_FORBIDDEN } from './httpConfig';

export class MarginPlanApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getPlans() {
    return this.#http.get('/api/margin-plans', SKIP_FORBIDDEN);
  }

  async getPlan(marginPlanId) {
    return this.#http.get(`/api/margin-plans/${marginPlanId}`, SKIP_FORBIDDEN);
  }

  async getPlanVersions(marginPlanId) {
    return this.#http.get(`/api/margin-plans/${marginPlanId}/versions`, SKIP_FORBIDDEN);
  }

  async createPlan(body) {
    return this.#http.post('/api/margin-plans', body, SKIP_FORBIDDEN);
  }

  async updatePlan(marginPlanId, body) {
    return this.#http.put(`/api/margin-plans/${marginPlanId}`, body, SKIP_FORBIDDEN);
  }

  async deletePlan(marginPlanId) {
    return this.#http.delete(`/api/margin-plans/${marginPlanId}`, SKIP_FORBIDDEN);
  }

  async activatePlan(marginPlanId) {
    return this.#http.post(`/api/margin-plans/${marginPlanId}/activate`, undefined, SKIP_FORBIDDEN);
  }

  async archivePlan(marginPlanId) {
    return this.#http.post(`/api/margin-plans/${marginPlanId}/archive`, undefined, SKIP_FORBIDDEN);
  }

  // Margin Center MC-7 (DEV-4969): draft-vs-live diff/preview — compute-on-read, no writes. `request`
  // is a MarginPreviewRequest (NoteRates/SubCompanyId/BranchId/BrokerId), all optional — an empty body
  // previews the plan's channel-level band across the server's DefaultNoteRates axis. DEV-4977/MC-14
  // additionally layers Summary.CoarseFloatingPipeline{LoanCount,LoanAmount,DollarImpact} onto the
  // response — the v1 COARSE whole-subtree floating-pipeline $ estimate (per-cell
  // floatingPipelineDollarImpact stays 0 until a separate per-(program×rate) attribution spike lands).
  async previewPlan(marginPlanId, request = {}) {
    return this.#http.post(`/api/margin-plans/${marginPlanId}/preview`, request, SKIP_FORBIDDEN);
  }
}
